var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.25H3C2.59 16.25 2.25 16.59 2.25 17C2.25 17.41 2.59 17.75 3 17.75H21C21.41 17.75 21.75 17.41 21.75 17C21.75 16.59 21.41 16.25 21 16.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.25H6C5.59 11.25 5.25 11.59 5.25 12C5.25 12.41 5.59 12.75 6 12.75H18C18.41 12.75 18.75 12.41 18.75 12C18.75 11.59 18.41 11.25 18 11.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.25H10C9.59 6.25 9.25 6.59 9.25 7C9.25 7.41 9.59 7.75 10 7.75H14C14.41 7.75 14.75 7.41 14.75 7C14.75 6.59 14.41 6.25 14 6.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeChangeIcon);
export default __webpack_public_path__ + "static/media/size-change-icon.63edf8fe4ed503b1e493fc3fb7e5b6b8.svg";
export { ForwardRef as ReactComponent };